import _ from 'lodash'

import {
  Json,
  ModelViewer,
  Pagination,
  LegacyPage,
  Bar,
  Panels,
} from 'peach/components'

const ApiCallResponse = ({ resp, params, onSetParams }) => {
  if (resp?.data) {
    const { data, ...rest } = resp

    const pagination = (
      <Pagination options={params} resp={resp} setOptions={onSetParams} />
    )

    const header = <Bar left={pagination} />

    return (
      <Panels header={_.has(rest, 'nextUrl') && header}>
        <LegacyPage.Full>
          <Json.Table json={rest} title='Metadata' />
          <ModelViewer json={data} title='Data' />
        </LegacyPage.Full>
      </Panels>
    )
  }
  return (
    <LegacyPage.Full>
      <ModelViewer json={resp} />
    </LegacyPage.Full>
  )
}

export default ApiCallResponse
